// Dependencies.
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vue from 'vue'
import App from './App.vue'
import plugins from './plugins'
import router from './router'
import store from './store'
// import './registerServiceWorker' // PWA temporariamente desabilitado

import { getApiBaseUrl } from './lib/apiBaseUrl'
Vue.config.productionTip = false
Vue.config.devtools = true


// Adding plugins.
Vue.use(plugins, { store })

// Inicializar dados do usuário se estiver logado
const initializeUserData = async () => {
  const isLoggedIn = localStorage.getItem('qrsconfig@login')
  const tokenJWT = localStorage.getItem('tokenJWT')
  
  // Sempre configurar a URL base da API usando as mesmas variáveis da autenticação
  const baseUrl = getApiBaseUrl()
  
  if (isLoggedIn && tokenJWT) {
    // Recuperar dados do usuário
    store.dispatch('autenticacao/initializeUserData')
    
    // Configurar autenticação com o token JWT e URL base
    store.dispatch('autenticacao/setAuthentication', { 
      token: tokenJWT, 
      baseUrl: baseUrl 
    })

    const palavraNoPerfil = store.getters['autenticacao/getUser']?.autenticacao2FA?.palavraChave2FA
    const palavraNaStore = store.getters['autenticacao2fa/getPalavraChave2FA']

    if (palavraNoPerfil && !palavraNaStore) {
      store.dispatch('autenticacao2fa/setPalavraChave2FA', palavraNoPerfil, true)
    } else if (!palavraNaStore) {
      await store.dispatch('autenticacao2fa/carregarPalavraChave2FA')
    }

    await store.dispatch('supervisao/fetchSupervisionados')
  } else {
    // Mesmo sem login, configurar a URL base para futuras requisições
    store.dispatch('autenticacao/setAuthentication', { 
      token: null, 
      baseUrl: baseUrl 
    })
  }
}

// Inicializar dados do usuário
initializeUserData()

// Vue instance.
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
